export default [
    {
        path: '/promote/reward', // 推广奖励
        name: 'authMode_reward',
        meta: {
            title: 'authMode_reward',
            icon: 'icon-yaoqing',
            // hideInMenu: true,
        },
        // component: () => import(/* webpackChunkName: "combind" */ '@/views/main/promote/Reward.vue'),
    },
];
